import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../api";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { IMAGE_URL } from "../../path";
import { HowToData } from "../types/Page";
import "../../styles/HowTo.scss";

function HowTo() {
    const { slug } = useParams();

    const [howToData, setHowToData] = useState<HowToData | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    async function fetchHowTo() {
        try {
            const res = await api.get(`/v1/how-to/${slug}`);

            console.log(res);

            setHowToData(res.data);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        fetchHowTo();
    }, [slug]);

    // Set the initial slide based on the URL slug
    useEffect(() => {
        if (!howToData?.categories?.length || !slug) {
            return;
        }

        const index = howToData.categories.findIndex(
            (category) => category.slug === slug
        );

        setCurrentIndex(index >= 0 ? index : 0);
    }, [howToData, slug]);

    function handleNext() {
        if (!howToData?.pages?.length) {
            return;
        }

        setCurrentIndex((prevIndex) =>
            prevIndex === howToData.pages.length - 1
                ? 0
                : prevIndex + 1
        );
    }

    function handlePrevious() {
        if (!howToData?.pages?.length) {
            return;
        }

        setCurrentIndex((prevIndex) =>
            prevIndex === 0
                ? howToData.pages.length - 1
                : prevIndex - 1
        );
    }

    if (!howToData) {
        return (
            <div>
                <Header />
            </div>
        );
    }

    const currentCategory = howToData.categories?.[currentIndex];

    if (!currentCategory) {
        return (
            <div>
                <Header />
            </div>
        );
    }

    const currentPage = howToData.pages?.[currentIndex];
    const pageCount = howToData.pages.length;

    return (
        <div>
            <Header />

            {pageCount > 0 && currentPage && (
                <div className="page-hero-top">
                    <div className="page-hero-track">
                        {(() => {
                            const header = currentPage.headers?.[0];

                            if (!header) {
                                return null;
                            }

                            return (
                                <div
                                    key={currentPage.slug}
                                    className="page-hero-inner active"
                                >
                                    <picture>
                                        {header.mobile_image && (
                                            <source
                                                media="(max-width: 840px)"
                                                srcSet={`${IMAGE_URL}/${header.mobile_image}`}
                                            />
                                        )}

                                        <img
                                            src={`${IMAGE_URL}/${header.image}`}
                                            alt={currentPage.name}
                                        />
                                    </picture>

                                    <div
                                        className="page-hero-nav"
                                        onClick={(event) =>
                                            event.stopPropagation()
                                        }
                                    >
                                        <button
                                            type="button"
                                            className="page-hero-arrow"
                                            onClick={handlePrevious}
                                            aria-label="Previous"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="38"
                                                height="38"
                                                viewBox="0 0 38 38"
                                            >
                                                <circle
                                                    cx="19"
                                                    cy="19"
                                                    r="18"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth="2"
                                                />

                                                <path
                                                    d="M21.5 11.5L14 19L21.5 26.5"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>

                                        <div className="page-hero-dots">
                                            {howToData.pages.map(
                                                (dotPage, dotIndex) => (
                                                    <button
                                                        type="button"
                                                        key={dotPage.slug}
                                                        className={`page-hero-dot ${
                                                            dotIndex ===
                                                            currentIndex
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                        onClick={() =>
                                                            setCurrentIndex(
                                                                dotIndex
                                                            )
                                                        }
                                                        aria-label={`Go to ${dotPage.name}`}
                                                    />
                                                )
                                            )}
                                        </div>

                                        <button
                                            type="button"
                                            className="page-hero-arrow"
                                            onClick={handleNext}
                                            aria-label="Next"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="38"
                                                height="38"
                                                viewBox="0 0 38 38"
                                            >
                                                <circle
                                                    cx="19"
                                                    cy="19"
                                                    r="18"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth="2"
                                                />

                                                <path
                                                    d="M16.5 11.5L24 19L16.5 26.5"
                                                    fill="none"
                                                    stroke="#fff"
                                                    strokeWidth="2.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}

            <div className="container">
                <div className="how-to-header">
                    <div className="text">
                        How To: {currentCategory.title}
                    </div>
                </div>

                {currentCategory.items &&
                    currentCategory.items.length > 0 && (
                        <div className="how-to-items">
                            <div className="how-to-items-inner">
                                {currentCategory.items.map((item, index) => (
                                    <div
                                        key={index}
                                        className="how-to-item"
                                    >
                                        <div className="image">
                                            <img
                                                src={`${IMAGE_URL}/${item.image}`}
                                                alt={item.title}
                                            />
                                        </div>

                                        <div className="body">
                                            <h1>{item.title}</h1>
                                            <p>{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                <Footer />
            </div>
        </div>
    );
}

export default HowTo;
